import { useQuery } from '@tanstack/react-query';
import { useTenantedClient, useWhoami } from '@cotera/client/app/stores/org';
import { queryKeys } from '@cotera/client/app/hooks/query-cache-keys';
import type { WebhookProviderCatalogEntry } from '../types';

export function useWebhookProviderCatalog(): {
  providers: readonly WebhookProviderCatalogEntry[];
  isLoading: boolean;
  isError: boolean;
} {
  const client = useTenantedClient();
  const orgId = useWhoami((s) => s.org.id);
  const query = useQuery({
    queryKey: queryKeys.webhookProviders.catalog({ orgId }),
    queryFn: async () => {
      const result = await client.webhookProviders.list();
      if (result.isErr()) {
        throw new Error(
          result.error.t === 'application'
            ? result.error.err.message
            : 'Failed to load webhook providers'
        );
      }
      return result.value.providers;
    },
  });
  return {
    providers: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}

export function findWebhookProviderCatalogEntry(
  providers: readonly WebhookProviderCatalogEntry[],
  providerKey: string
): WebhookProviderCatalogEntry | undefined {
  return providers.find((entry) => entry.key === providerKey);
}
